/**
 * DevExtreme (esm/__internal/scheduler/utils/resource_manager/appointment_color_utils.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { getAppointmentGroupValues, getResourceItemById } from "./appointment_groups_utils";
import { getLeafGroupValues } from "./group_utils";
export const getPaintedResource = (resources, appointmentGroups, groups) => {
  const assignedResources = resources.filter(resource => appointmentGroups.includes(resource.resourceIndex));
  const defaultColorResource = assignedResources.find(resource => resource.useColorAsDefault);
  if (defaultColorResource) {
    return defaultColorResource;
  }
  const assignedGroups = groups.filter(group => appointmentGroups.includes(group));
  const availableGroupedResources = assignedGroups.map(group => assignedResources.find(resource => resource.resourceIndex === group)).filter(Boolean);
  return availableGroupedResources.length ? availableGroupedResources.at(-1) : assignedResources.at(-1);
};
const getResourceColor = (resource, resourceId) => {
  var _getResourceItemById;
  return null === (_getResourceItemById = getResourceItemById(resource, resourceId)) || void 0 === _getResourceItemById ? void 0 : _getResourceItemById.color;
};
export const getAppointmentColor = async (resources, groupsLeafs, groups, appointmentConfig) => {
  const {
    groupIndex: groupIndex,
    itemData: itemData
  } = appointmentConfig;
  const appointmentGroupValues = getAppointmentGroupValues(itemData, resources);
  const appointmentGroups = Object.keys(appointmentGroupValues);
  const paintedResource = getPaintedResource(resources, appointmentGroups, groups);
  if (!paintedResource) {
    return;
  }
  await paintedResource.load();
  const leafGroupValue = getLeafGroupValues(groupsLeafs, groupIndex);
  const resourceValues = paintedResource.idsGetter(itemData);
  const resourceId = leafGroupValue[paintedResource.resourceIndex] ?? resourceValues[0];
  return getResourceColor(paintedResource, resourceId);
};